export default __webpack_public_path__ + "static/media/src_img_17.7b161262.png";